exports.appId = "22682"
exports.appSecret = "9c0b59dc-f074-4e62-b54f-e891d0cc66d9"
exports.url = "https://api.internal.braincloudservers.com"
